import {
  CLEAR_SYNDICATE,
  CLEAR_STATE,

  DELETE_SYNDICATE,
  DELETE_SYNDICATE_ERROR,
  DELETE_SYNDICATE_SUCCESS,

  GET_SYNDICATE,
  GET_SYNDICATE_ERROR,
  GET_SYNDICATE_SUCCESS,

  GET_SYNDICATES,
  GET_SYNDICATES_ERROR,
  GET_SYNDICATES_SUCCESS,

  SAVE_SYNDICATE_LINKS,
  SAVE_SYNDICATE_LINKS_SUCCESS,
  SAVE_SYNDICATE_LINKS_ERROR,

  SAVE_SYNDICATE,
  SAVE_SYNDICATE_ERROR,
  SAVE_SYNDICATE_SUCCESS,

  SAVE_PASSWORD,
  SAVE_PASSWORD_ERROR,
  SAVE_PASSWORD_SUCCESS,

  SAVE_ADMINISTRATORS,
  SAVE_ADMINISTRATORS_ERROR,
  SAVE_ADMINISTRATORS_SUCCESS,

  GET_ADMINISTRATORS,
  GET_ADMINISTRATORS_ERROR,
  GET_ADMINISTRATORS_SUCCESS,

  SAVE_COMMON_CHARGE,
  SAVE_COMMON_CHARGE_ERROR,
  SAVE_COMMON_CHARGE_SUCCESS,

  SAVE_DOCUMENT,
  SAVE_DOCUMENT_ERROR,
  SAVE_DOCUMENT_SUCCESS,

} from './constants';

export default {
  [CLEAR_SYNDICATE](state) {
    state.syndicate = {
      type: 'HORIZONTAL',
      name: null,
      shortname: null,
      streetNumber: null,
      streetName: null,
      creationDate: null,
      organizationNumber: null,
      organizationName: null,
      commonCharge: null,
      account: null,
      institution: null,
      field: null,
      insurance: null,
      aga: null,
      pga: null,
      rules: null,
      declaration: null,
      req: null,
      agaDate: null,
      pgaDate: null,
      horizontal: null,
      email: null,
      dayOfMonth: null,
      reportFrequency: 'MONTHLY',
      emailDRD: null,
      reportFrequencyDRD: 'MONTHLY',
      syndicateManagers: [],
      syndicateAdministrators: [],
      boardMemberUsers: [],
    };
  },

  [CLEAR_STATE](state) {
    state.error = false;
    state.success = false;
  },

  [DELETE_SYNDICATE](state) {
    state.error = false;
    state.loading = true;
  },
  [DELETE_SYNDICATE_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [DELETE_SYNDICATE_SUCCESS](state) {
    state.syndicate = false;
    state.loading = false;
  },

  [GET_SYNDICATE](state) {
    state.syndicate = false;
    state.error = false;
    state.loading = true;
  },
  [GET_SYNDICATE_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_SYNDICATE_SUCCESS](state, payload) {
    state.syndicate = payload;
    state.loading = false;
  },

  [GET_SYNDICATES](state) {
    state.syndicates = [];
    state.error = false;
    state.loading = true;
  },
  [SAVE_SYNDICATE_LINKS](state, payload) {
    state.syndicateLink = payload.data;
    state.error = payload.error || false;
    state.loading = true;
  },
  [SAVE_SYNDICATE_LINKS_SUCCESS](state, payload) {
    state.syndicateLink = payload;
    state.loading = false;
  },
  [SAVE_SYNDICATE_LINKS_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.formLoading = false;
  },
  [GET_SYNDICATES_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_SYNDICATES_SUCCESS](state, payload) {
    state.syndicates = payload;
    state.loading = false;
  },

  [SAVE_SYNDICATE](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [SAVE_SYNDICATE_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.formLoading = false;
  },
  [SAVE_SYNDICATE_SUCCESS](state, payload) {
    state.syndicate = payload;
    state.success = true;
    state.formLoading = false;
  },

  [SAVE_PASSWORD](state) {
    state.error = false;
    state.formLoading = true;
    state.success = false;
  },
  [SAVE_PASSWORD_ERROR](state, payload) {
    state.error = payload;
    state.formLoading = false;
  },
  [SAVE_PASSWORD_SUCCESS](state, payload) {
    state.syndicate = payload;
    state.success = true;
    state.formLoading = false;
  },

  [SAVE_ADMINISTRATORS](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [SAVE_ADMINISTRATORS_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.formLoading = false;
  },
  [SAVE_ADMINISTRATORS_SUCCESS](state, payload) {
    state.syndicate.syndicateAdministrators = payload;
    state.success = true;
    state.formLoading = false;
  },

  [GET_ADMINISTRATORS](state) {
    state.syndicate.syndicateAdministrators = [];
    state.syndicateAdministrators = [];
    state.error = false;
    state.loading = true;
  },
  [GET_ADMINISTRATORS_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_ADMINISTRATORS_SUCCESS](state, payload) {
    state.syndicate.syndicateAdministrators = payload;
    state.syndicateAdministrators = payload.map(a => Object.assign({}, a));
    state.loading = false;
  },

  [SAVE_COMMON_CHARGE](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [SAVE_COMMON_CHARGE_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.formLoading = false;
  },
  [SAVE_COMMON_CHARGE_SUCCESS](state) {
    state.success = true;
    state.formLoading = false;
  },

  [SAVE_DOCUMENT](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [SAVE_DOCUMENT_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.formLoading = false;
  },
  [SAVE_DOCUMENT_SUCCESS](state, payload) {
    state.success = true;
    state.syndicate.documentLink = payload.documentLink;
    state.formLoading = false;
  },

  // single object item mutation
  updateItem(state, payload) {
    state.syndicate[payload.item] = payload.value;
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/mutations.js